/**
 * @fileoverview Agent definition for the single-chapter-extractor-v2 primitive.
 *
 * This agent analyzes text and extracts both plot structure and single-chapter
 * metadata in one pass. Optimized for short-form fiction (Flash Fiction, Short Story)
 * but can be used for any single-chapter content.
 *
 * Use this agent instead of plot-extractor-v2 + chapter-extractor-v2 when importing
 * single-chapter content.
 *
 * @category import.story.extraction
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'single-chapter-extractor-v2',
  kind: 'primitive',
  name: 'Single Chapter Extractor',
  description:
    'Extracts plot structure and chapter metadata from single-chapter content in a single pass.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2025-01',
    lastUpdated: '2026-02',
    taxonomyPath: 'import.story.extraction',
    usedBy: ['ImportPage', 'use-single-chapter-extractor-v2.ts'],
    relatedAgents: ['story-dna-extractor-v2', 'plot-extractor-v2', 'chapter-extractor-v2'],
  },
};
